import { LoadingButton } from "@mui/lab";
import { Box, Grid } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import cartStore from "../../../../store/cartStore";
import authStore from "../../../../store/authStore";
import ReactPixel from "react-facebook-pixel";
import { useNavigate } from "react-router-dom";
import { ENV } from "constant";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const FirstContent = ({
  id,
  image,
  title,
  shortDescription,
  productName,
  regularPrice,
  salePrice,
}) => {
  const sectionRef = useRef(null);
  const imageRef = useRef(null);
  const contentRef = useRef(null);

  const CartStore = cartStore();
  const AuthStore = authStore();
  const [isAddToCart, setIsAddToCart] = useState(false);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (CartStore.cartProduct) {
      setIsAddToCart(false);
      const product = CartStore.cartProduct.find(
        (item) => item.productID === id,
      );
      if (product) {
        setIsAddToCart(true);
      }
    }
  }, [CartStore.cartProduct && CartStore.cartProduct.length, id]);

  const AddToCart = async () => {
    if (AuthStore.isLogged) {
      setIsLoading(true);
      await CartStore.signInAdd({
        productID: id,
        selectedColor: null,
        selectedSize: null,
      });
      setIsLoading(false);
    } else {
      await CartStore.noSignInAdd({
        productID: id,
        selectedColor: null,
        selectedSize: null,
      });
    }

    if (ENV === "production") {
      ReactPixel.track("AddToCart", {
        content_ids: [id],
        content_name: productName,
        value: salePrice ? salePrice : regularPrice,
        currency: "INR",
      });
    }
    navigate("/checkout");
  };

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Content animation
      // gsap.from(contentRef.current, {
      //   y: 50,
      //   opacity: 0,
      //   duration: 1,
      //   ease: "power3.out",
      //   scrollTrigger: {
      //     trigger: sectionRef.current,
      //     start: "top 80%",
      //     toggleActions: "play none none none",
      //   },
      // });

      // // Image animation (bottom → top)
      gsap.from(imageRef.current, {
        y: 120,
        opacity: 0,
        delay: 0.5,
        duration: 2,
        ease: "power4.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
          toggleActions: "play none none none",
        },
      });

      gsap.from(".content > *:not(.skip-animate)", {
        y: 40,
        opacity: 0,
        stagger: 0.5,
        duration: 2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
        },
      });
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <Grid container rowSpacing={2} className="grid-container" ref={sectionRef}>
      <Grid
        display={{
          xs: "block",
          lg: "none",
          sm: "none",
          md: "none",
        }}
        item
        sm={6}
        className="image-container"
      >
        <div className="content">
          <Box
            // ref={imageRef}
            component="img"
            sx={{
              objectFit: "contain",
              width: "100%",
              height: "100%",
            }}
            className="mainProductImage"
            src={image}
          />
        </div>
      </Grid>
      <Grid item sm={6} className="main-container">
        <div className="content" ref={contentRef}>
          <h1>{title}</h1>
          <p>{shortDescription}</p>
          <div>
            <div className="price">
              {salePrice && <div className="sale-price">₹{salePrice}</div>}
              <div className={`regular-price ${salePrice && "is-sale"}`}>
                ₹{regularPrice}
              </div>
            </div>
          </div>

          <LoadingButton
            loading={isLoading}
            onClick={
              isAddToCart
                ? () => {
                    navigate("/checkout");
                  }
                : AddToCart
            }
            variant="contained"
            className="btn buy-btn"
          >
            Buy
          </LoadingButton>
        </div>
      </Grid>
      <Grid
        item
        sm={6}
        display={{
          xs: "none",
          lg: "block",
          sm: "block",
          md: "block",
        }}
        className="image-container"
      >
        <div className="content">
          <Box
            ref={imageRef}
            component="img"
            sx={{
              objectFit: "contain",
              width: "100%",
              height: "100%",
            }}
            className="mainProductImage skip-animate"
            src={image}
          />
        </div>
      </Grid>
    </Grid>
  );
};

export default FirstContent;
